var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpsellingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1184 15.4609C19.1184 15.755 18.863 16 18.548 16H5.98379C5.79651 16 5.61776 15.9183 5.51561 15.7631C5.40495 15.6161 5.38792 15.4282 5.45602 15.2649L6.52007 12.7328L5.0304 4.77928C4.90272 4.48523 4.46859 3.2007 4.36644 3.10268C3.81313 3.07818 2.58735 3.07818 2.57033 3.07818C2.25537 3.07818 2 2.83314 2 2.53909C2 2.24504 2.25537 2 2.57033 2C2.62991 2 3.99189 2 4.51966 2.03267C5.02189 2.06534 5.70288 3.57858 5.98379 4.15034H20.4803C20.8038 4.15034 21.0507 4.39538 20.9911 4.66492L18.8289 12.9697C18.7779 13.182 18.5651 13.3372 18.3097 13.3372H7.49048L6.82651 14.9218H18.5566C18.863 14.9218 19.1184 15.1669 19.1184 15.4609Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 19.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 19.5,
    r: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsellingIcon);
export default __webpack_public_path__ + "static/media/upselling_icon.cea897aecfd6a5dfa0bdd83543620ae0.svg";
export { ForwardRef as ReactComponent };